import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withQuery, withMutation } from '../../../hoc/withGraphql';
import getUserOverview from './getUserOverview.graphql';
import setUserStatusM from './setUserStatus.graphql';

const RED = '#D32F2F';
const TEAL = '#0E9488';
const INK = '#1F2733';

class User360 extends Component {
  constructor(props) {
    super(props);
    this.state = { query: '', searched: false, busy: false, message: '' };
  }

  data = () => (this.props.overview && this.props.overview.getUserOverview) || null;

  search = () => {
    if (!this.state.query) { this.setState({ message: 'Enter a user id or email.' }); return; }
    this.setState({ searched: true, message: '' });
    this.props.overview.refetch({ query: this.state.query });
  };

  act = async (vars, label) => {
    const d = this.data();
    if (!d || !d.userId) return;
    if (!window.confirm(`${label} this user?`)) return;
    this.setState({ busy: true, message: '' });
    try {
      const res = await this.props.setStatusMut({ variables: { userId: d.userId, ...vars } });
      const r = res && res.data && res.data.setUserStatus;
      if (r && r.status === 200) {
        this.setState({ busy: false, message: `✅ ${label} done.` });
        this.props.overview.refetch({ query: this.state.query });
      } else {
        this.setState({ busy: false, message: (r && r.errorMessage) || 'Action failed.' });
      }
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  render() {
    const d = this.data();
    const loading = this.props.overview && this.props.overview.loading;
    const ok = d && d.status === 200;
    const isProvider = ok && d.userType === 2;
    const cur = (ok && d.recentBookings && d.recentBookings[0] && d.recentBookings[0].currency) || 'USD';
    const sign = cur === 'USD' ? '$' : '';

    const input = { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginRight: 8, width: 320 };
    const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', marginRight: 8 });
    const kpi = (label, value, color) => (
      <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: '12px 16px', minWidth: 120 }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: color || INK }}>{value}</div>
        <div style={{ fontSize: 12, color: '#666' }}>{label}</div>
      </div>
    );
    const th = { padding: 10, textAlign: 'left' };
    const td = { padding: 10, borderTop: '1px solid #f0f0f0', fontSize: 13 };

    return (
      <div style={{ fontFamily: 'Poppins, sans-serif' }}>
        <h1 className="siteAdminPrimaryHeading">User 360</h1>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 14, marginBottom: 16 }}>
          <input style={input} placeholder="User id, email or phone" value={this.state.query}
                 onChange={(e) => this.setState({ query: e.target.value })}
                 onKeyDown={(e) => e.key === 'Enter' && this.search()} />
          <button style={btn(RED)} onClick={this.search}>Search</button>
          {this.state.message ? <span style={{ marginLeft: 12, color: RED, fontWeight: 600 }}>{this.state.message}</span> : null}
        </div>

        {loading && <div>Loading…</div>}
        {this.state.searched && !loading && d && d.status !== 200 && (
          <div style={{ color: '#C62828' }}>{d.errorMessage}</div>
        )}

        {ok && (
          <div>
            {/* Profile */}
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 16, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 20, fontWeight: 800 }}>{(d.firstName || '') + ' ' + (d.lastName || '') || '(no name)'}</div>
                <div style={{ color: '#666' }}>{d.email}</div>
                <div style={{ marginTop: 6, fontSize: 13 }}>
                  <span style={{ padding: '2px 10px', borderRadius: 999, background: isProvider ? '#1565C0' : TEAL, color: '#fff', fontWeight: 700, marginRight: 8 }}>{isProvider ? 'Provider' : 'Customer'}</span>
                  <span style={{ padding: '2px 10px', borderRadius: 999, background: d.isBan ? '#C62828' : (d.userStatus === 'inactive' ? '#9E9E9E' : '#2E7D32'), color: '#fff', fontWeight: 700 }}>
                    {d.isBan ? 'Banned' : (d.userStatus === 'inactive' ? 'Suspended' : 'Active')}
                  </span>
                  <span style={{ marginLeft: 12, color: '#888' }}>Joined {d.joinedAt} · Wallet {sign}{d.walletBalance}</span>
                </div>
              </div>
              <div>
                {d.isBan
                  ? <button style={btn('#2E7D32')} disabled={this.state.busy} onClick={() => this.act({ isBan: 0, userStatus: 'active' }, 'Unban')}>Unban</button>
                  : <button style={btn('#C62828')} disabled={this.state.busy} onClick={() => this.act({ isBan: 1 }, 'Ban')}>Ban</button>}
                {!d.isBan && (d.userStatus === 'inactive'
                  ? <button style={btn('#2E7D32')} disabled={this.state.busy} onClick={() => this.act({ userStatus: 'active' }, 'Reactivate')}>Reactivate</button>
                  : <button style={btn('#9E9E9E')} disabled={this.state.busy} onClick={() => this.act({ userStatus: 'inactive' }, 'Suspend')}>Suspend</button>)}
              </div>
            </div>

            {/* Scorecard */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 18 }}>
              {kpi('Total bookings', d.totalBookings)}
              {kpi('Completed', d.completed, '#2E7D32')}
              {kpi('Cancelled', d.cancelled, '#C62828')}
              {kpi('Completion rate', `${d.completionRate}%`)}
              {kpi(isProvider ? 'Total earned' : 'Total spent', `${sign}${d.totalValue}`, RED)}
              {isProvider && kpi('Avg rating', `${d.avgRating} ★`, '#F9A825')}
              {isProvider && kpi('Reviews', d.reviewsCount)}
            </div>

            {/* Recent bookings */}
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ padding: '10px 14px', fontWeight: 700, borderBottom: '1px solid #f0f0f0' }}>Recent bookings</div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead><tr style={{ background: '#fafafa' }}><th style={th}>#</th><th style={th}>Status</th><th style={th}>Value</th><th style={th}>Date</th></tr></thead>
                <tbody>
                  {d.recentBookings.length === 0 && <tr><td style={td} colSpan={4}>No bookings.</td></tr>}
                  {d.recentBookings.map((b) => (
                    <tr key={b.id}><td style={td}>#{b.id}</td><td style={td}>{b.status}</td><td style={td}>{sign}{b.totalFare}</td><td style={td}>{b.createdAt}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default compose(
  withQuery(getUserOverview, { name: 'overview', options: { variables: { query: '' }, fetchPolicy: 'network-only', ssr: false } }),
  withMutation(setUserStatusM, { name: 'setStatusMut' }),
)(User360);
